import { FC } from 'react';

interface Props {
  position: { top: string | null; right: string | null; left: string | null };
  stroke: boolean;
  className?: string;
}

const EphemeralMessageStrokeTop: FC<Props> = ({ position, stroke, className = '' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="38"
      viewBox="0 0 31 38"
      fill="none"
      className={className}
      style={{
        position: 'absolute',
        top: `${position?.top}`,
        right: `${position?.right ? position?.right : ''}`,
        left: `${position?.left ? position?.left : ''}`,
        zIndex: '6',
      }}
    >
      {stroke && (
        <>
          <path
            d="M2 7.66797C2.00002 6.07433 3.88049 4.97903 5.34473 5.89746C8.9087 8.1332 13.5348 10.8752 18.0332 13.0645C20.2823 14.159 22.5314 15.1309 24.6211 15.833C25.9521 16.2802 27.2715 16.6348 28.5186 16.8311C28.5185 16.8616 28.5187 16.8922 28.5186 16.9229C16.9583 16.7357 10.2592 21.1251 6.48633 25.957C4.52793 28.4652 3.41628 31.0163 2.79297 32.9375C2.60447 33.5185 2.46227 34.0456 2.35156 34.5H2V7.66797Z"
            fill="#FEFBF9"
            stroke="#F1F0EE"
            strokeWidth="4"
          />
          <path d="M26.5 38L4 38L4 8L27 20L26.5 38Z" fill="#FEFBF9" />
        </>
      )}
    </svg>
  );
};

export default EphemeralMessageStrokeTop;
